import React, { useState, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

import { useClickOutside } from "../../hooks/useClickOutside";

export const ToolbarButton = ({ btns }) => {
  const [toggleMenu, setToogleMenu] = useState(false);
  const targetEl = useRef();
  const handleToggleMenu = useCallback(
    () => setToogleMenu(!toggleMenu),
    [toggleMenu]
  );
  useClickOutside(targetEl, () => setToogleMenu(false));

  return (
    <div className="btn-toolbar" ref={targetEl}>
      <span className="btn-toolbar-trigger" onClick={handleToggleMenu}></span>
      {toggleMenu && (
        <ul className="row-actions">
          {btns
            .filter(({ show = true }) => show)
            .map(({ btnUrl, btnText, handleClick, danger }) => (
              // `key` was missing, so React re-keyed the whole menu by index on
              // every toggle.
              <li key={btnText}>
                {btnUrl ? (
                  <Link to={btnUrl}>{btnText}</Link>
                ) : (
                  // A plain button: `variant="link"` styled this as a body-copy
                  // link, so "Delete" rendered in a different size and weight
                  // from the "View" and "Edit" entries above it in the same
                  // menu (and dropped a literal "undefined" into its class).
                  <button
                    type="button"
                    className={danger ? "is-danger" : undefined}
                    onClick={handleClick}
                  >
                    {btnText}
                  </button>
                )}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default ToolbarButton;
